import CalendarIcon from "assets/images/Calendar";
import ClockIcon from "assets/images/Clock";
import {format} from "date-fns";
import {useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {appointmentDetails as strings} from "strings";

import Button from "components/Button";
import CancelAppointmentModal from "components/CancelAppointmentModal";
import Divider from "components/Divider";
import MobileNavigationHeader from "components/MobileNavigationHeader";

import {useAuthenticatedUser} from "lib/auth";

import styles from "./AppointmentDetailsPage.module.css";

type LocationState = {
  selectedPatientId: string;
  campaignName: string;
  campaignDescription?: string;
  optionName?: string;
  scheduledDateTime: string;
};

export default function AppointmentDetailsPage() {
  const location = useLocation();
  const locationState = location.state as LocationState;
  const selectedPatientId = locationState.selectedPatientId;
  const campaignName = locationState.campaignName;
  const campaignDescription = locationState.campaignDescription;
  const optionName = locationState.optionName;
  const scheduledDateTime = locationState.scheduledDateTime;
  const appointmentId = useParams().id ?? "";

  const [authenticatedUser] = useAuthenticatedUser();
  const patient = authenticatedUser?.data?.linkedPatients?.find(
    (linkedPatient) => linkedPatient.patientId === selectedPatientId,
  );
  const [showCancelModal, setShowCancelModal] = useState(false);

  return (
    <div>
      <MobileNavigationHeader backTo="/appointments" />
      {authenticatedUser?.data.linkedPatients?.length ? (
        <>
          <div className={styles.title}>{strings.appointmentDetails}</div>
          <div className={styles.patientName}>
            {patient
              ? patient.firstName + " " + patient.lastName
              : authenticatedUser?.data.name}
          </div>
        </>
      ) : (
        <div className={styles.patientName}>{authenticatedUser?.data.name}</div>
      )}
      <Divider className={styles.divider} />
      <div className={styles.appointmentName}>
        {optionName} - {campaignName}
      </div>
      <div>{campaignDescription}</div>
      <Divider className={styles.divider} />
      <div className={styles.detailsRow}>
        <div className={styles.detailsRowTitle}>
          <div className={styles.detailsIcon}>
            <CalendarIcon />
          </div>

          <div className={styles.detailsText}>{strings.date}</div>
        </div>
        <div className={styles.detailsText}>
          {format(new Date(scheduledDateTime), "MM/dd/yy")}
        </div>
      </div>
      <Divider className={styles.divider} />
      <div className={styles.detailsRow}>
        <div className={styles.detailsRowTitle}>
          <div className={styles.detailsIcon}>
            <ClockIcon />
          </div>

          <div className={styles.detailsText}>{strings.time}</div>
        </div>
        <div className={styles.detailsText}>
          {format(new Date(scheduledDateTime), "hh:mm aaa")}
        </div>
      </div>
      <Divider className={styles.divider} />
      <Button
        className={styles.cancelAppointmentButton}
        variant="filled"
        onClick={() => setShowCancelModal(true)}
      >
        {strings.cancelAppointment}
      </Button>
      <CancelAppointmentModal
        visible={showCancelModal}
        onClickClose={() => setShowCancelModal(false)}
        appointmentId={appointmentId}
        patientId={selectedPatientId}
      />
    </div>
  );
}
